import { AfterContentChecked, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { ScriptLoaderService } from '@app/core/services/script-loader.service';
import { HelperService } from '@app/core/services/helper.service';

import Swiper, { SwiperOptions } from 'swiper';

@Component({
	selector: 'cng-gallery',
	templateUrl: './gallery.component.html',
	styleUrls: ['./gallery.component.less'],
})
export class ConfigureGalleryComponent implements OnInit, AfterContentChecked {
	@Input() images: Array<any>;
	@Input() show_pagination: boolean = false;
	@Input() pagination_type: string = 'fraction';

	@Output() imageRemoved: EventEmitter<any> = new EventEmitter<any>();

	@ViewChild('swiper') swiper: any;

	update_timeout: any = null;
	swiper_loaded: boolean = false;
	swiper_config: SwiperOptions = null;
	swiper_init: boolean = false;
	swiper_updated_once: boolean = false;

	constructor(private script_loader_service: ScriptLoaderService, private helper_service: HelperService) {}

	ngOnInit(): void {
		this.swiper_config = {
			loop: this.images.length > 1,
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
				type: 'fraction',
			},
			spaceBetween: 0,
			slidesPerView: 'auto',
			watchOverflow: this.images.length <= 1,
			initialSlide: 0,
			grabCursor: true,
			centeredSlides: true,
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		};

		// LOAD EXTERNAL SCRIPTS
		this.script_loader_service.load({ name: 'swiper' }).then(() => {
			this.swiper_loaded = true;
		});
	}

	ngAfterContentChecked(): void {
		if (typeof this.swiper !== 'undefined' && !this.swiper_init) {
			if (this.helper_service.browserSupports('swiper.update')) {
				this.updateSwiper(this.swiper.Swiper);
			}
			this.swiper_init = true;
		}
	}

	onImageError(index: number): void {
		this.removeImage(index);
	}

	removeImage(index: number): void {
		this.images.splice(index, 1);
		this.imageRemoved.emit(index);
	}

	updateSwiper(swiper: Swiper, delay: number = 300): void {
		if (typeof swiper !== 'undefined') {
			this.swiper_updated_once = true;
			swiper.update();
		}
	}
}
